export default __webpack_public_path__ + "static/N0023-7e3f9d44e71945c9dcc3a9bc245dc983.png";